module.exports = __webpack_public_path__ + "static/media/light-home-small.ea392b52.png";